var _path, _rect, _rect2, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlayBtnGray(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.8066 0C29.4075 0 33.1707 3.91746 33.1707 9.76546V23.3887C33.1707 23.5358 33.1553 23.6737 33.1399 23.8115C33.1301 23.8984 33.1204 23.9851 33.1146 24.0742C32.1516 23.5296 31.0389 23.2188 29.8536 23.2188C26.1897 23.2188 23.2195 26.189 23.2195 29.8529C23.2195 31.0553 23.5393 32.1829 24.0986 33.1554C24.0032 33.1645 23.9064 33.1707 23.8066 33.1707H9.35083C8.72722 33.1707 8.13181 33.1077 7.55629 33.0132C7.53502 33.0099 7.51536 33.0066 7.49572 33.0034L7.49493 33.0032C5.25093 32.6168 3.38839 31.5338 2.08312 29.9001C2.07406 29.9001 2.0705 29.894 2.06576 29.8858C2.06269 29.8806 2.05913 29.8744 2.05327 29.8686C0.741366 28.2167 0 25.9959 0 23.3887V9.76546C0 3.91746 3.76654 0 9.35083 0H23.8066Z",
    fill: "#D1D7E3"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 29.0234,
    y: 25.707,
    width: 1.65854,
    height: 8.29268,
    rx: 0.829268,
    fill: "#D1D7E3"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 29.0234,
    width: 1.65854,
    height: 8.29268,
    rx: 0.829269,
    transform: "rotate(90 34 29.0234)",
    fill: "#D1D7E3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2676 22.391V11.2278V10.7812L23.4261 16.5861L13.2676 22.391Z",
    fill: "#F6F8FA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayBtnGray);
export default __webpack_public_path__ + "static/media/playBtnGray.b6a5e95a.svg";
export { ForwardRef as ReactComponent };